import { render, staticRenderFns } from "./IP_ByDrg.vue?vue&type=template&id=7318f5d4&scoped=true&"
import script from "./IP_ByDrg.vue?vue&type=script&lang=js&"
export * from "./IP_ByDrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318f5d4",
  null
  
)

export default component.exports